module.exports = require('./injectGlobalJss')
